/**
 * Transaction Status Constants
 * Centralized status definitions with environment variable fallbacks
 */

// Transaction status values from environment variables
export const TRANSACTION_STATUSES = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  DROP: 'DROP',
  CANCELLED: 'CANCELLED',
  INITIATED: 'INITIATED',
  
} as const;

export const SETTLED_STATUSES = {
  SUCCESS: 'SETTLED',
  FAILURE: 'FAILURE',
  DROP: 'DROP',
  CANCELLED: 'CANCELLED',
  INITIATED: 'INITIATED',
  SETTLED : 'SETTLED',
  HOLD: 'HOLD'
} as const;

// Export status keys as a type
export type TransactionStatus = keyof typeof TRANSACTION_STATUSES;

// Status groupings for different use cases
export const STATUS_GROUPS = {
  SUCCESSFUL: ['SUCCESS'] as const,
  FAILED: ['FAILURE', 'DROP', 'CANCELLED'] as const,
  PENDING: ['INITIATED'] as const,
} as const;

// Status colors mapping for UI components
export const STATUS_COLORS = {
  SUCCESS: 'success',
  FAILURE: 'error',
  DROP: 'error',
  CANCELLED: 'error',
  INITIATED: 'warning',
} as const;

// Status display names (if different from keys)
export const STATUS_DISPLAY_NAMES = {
  SUCCESS: 'Successful',
  FAILURE: 'Failure',
  DROP: 'Dropped',
  CANCELLED: 'Cancelled',
  INITIATED: 'Initiated',
} as const;

// Helper functions
export const isSuccessfulStatus = (status: TransactionStatus): boolean => {
  return STATUS_GROUPS.SUCCESSFUL.includes(status as unknown as 'SUCCESS');
};

export const isFailedStatus = (status: TransactionStatus): boolean => {
  return STATUS_GROUPS.FAILED.includes(status as unknown as 'FAILURE' | 'DROP' | 'CANCELLED');
};

export const isPendingStatus = (status: TransactionStatus): boolean => {
  return STATUS_GROUPS.PENDING.includes(status as unknown as 'INITIATED');
};

export const getStatusColor = (status: TransactionStatus): string => {
  return STATUS_COLORS[status] || 'default';
};

export const getStatusColorSatlement = (status: TransactionStatus): string => {
  return STATUS_COLORS[status] || 'default';
};

export const getStatusDisplayName = (status: TransactionStatus): string => {
  return STATUS_DISPLAY_NAMES[status] || status;
};
